import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../Firebase/firebase';

export const getPostById = async (postID) => {
    try {
      const postRef = doc(db, 'posts', postID); // 'posts' is the collection name
      const postDoc = await getDoc(postRef);
      if (postDoc.exists()) {
        return postDoc.data(); // Returns the post data
      } else {
        console.error('No post found with the given ID.');
        return null;
      }
    } catch (error) {
      console.error('Error fetching post:', error);
      return null;
    }
  };